import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FiscalModel } from './fiscalModels/fiscal.model';

@Injectable({
  providedIn: 'root',
})
export class FiscalService {
  constructor(private http: HttpClient) {}

  getFiscalModel(fiscalModel: FiscalModel): Promise<Blob> {
    return firstValueFrom(
      this.http.post(environment.apiUrl + '/fiscalModel', fiscalModel, {
        responseType: 'blob',
      })
    ).then((response) => {
      return new Blob([response], { type: 'text/html' });
    });
  }
}